import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
import Box from "@material-ui/core/Box";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon/ListItemIcon";
import Radio from "@material-ui/core/Radio/Radio";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import {formatCurrency} from "../../../../../utils";
import List from "@material-ui/core/List";
import {useTranslation} from "react-i18next";
import {Container} from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery/useMediaQuery";
import useTheme from "@material-ui/core/styles/useTheme";
const sprintf = require('sprintf-js').sprintf;

const useStyles = makeStyles(theme => ({
  listItem: {
    backgroundColor: '#F6F6F6',
    marginBottom: '2px'
  },
  selected: {
    '&.MuiListItem-root, &.MuiListItem-root:active, &.MuiListItem-root:hover': {
      backgroundColor: theme.palette.secondary.light
    }
  },
}));

export default ({pickupLocation, deliveryType, setPickupLocation}) => {
  const classes = useStyles();
  const {t} = useTranslation();
  const theme = useTheme();
  const disableGutters = useMediaQuery(theme.breakpoints.down('sm'));

  const pickupLocations = deliveryType.pickupLocations.filter(e =>
    e.uuid.substring(0, 24) == pickupLocation.uuid.substring(0, 24))

  return <Box mb={2} mt={2}>
    <Container disableGutters={disableGutters} maxWidth="sm">
    <List>
    {pickupLocations.map((pl) => {
      let description = t('Standard delivery');
      if (pl.uuid.substring(24) == '111111111111') {
        description = t('Express delivery');
      }
      let deliveryInfo = '';
      if (pl.deliverytimeunit == 'd') {
        if (pl.deliverytime == 1) {
          deliveryInfo = t('Your order will be ready within %d business day', { postProcess: 'sprintf', sprintf: [ pl.deliverytime ] })
        }
        else {
          deliveryInfo = t('Your order will be ready within %d business days', { postProcess: 'sprintf', sprintf: [ pl.deliverytime ] })
        }
      }
      else if (pl.deliverytimeunit == 'h') {
        if (pl.deliverytime == 1) {

          deliveryInfo = t('Your order will be ready within %d hour', { postProcess: 'sprintf', sprintf: [ pl.deliverytime ] })
        }
        else {
          deliveryInfo = t('Your order will be ready within %d hours', { postProcess: 'sprintf', sprintf: [ pl.deliverytime ] })
        }
      }

      console.log('Pickup location')
      console.log('Pickup location', pl)
      const labelId = pl.uuid;
      return <ListItem key={pl.uuid} button selected={pl.uuid == pickupLocation.uuid} classes={{selected: classes.selected}}
                       onClick={() => setPickupLocation(pl)} className={classes.listItem}>
        <ListItemIcon>
          <Radio edge="start"
                 checked={pl.uuid == pickupLocation.uuid}
                 inputProps={{ 'aria-labelledby': labelId }}
          />
        </ListItemIcon>
        <ListItemText  id={labelId} primary={description} secondary={deliveryInfo}/>
        <Box style={{whiteSpace: 'nowrap'}}>{formatCurrency(pl.price)}</Box>
      </ListItem>
    })}
  </List>
    </Container>
  </Box>
}